"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.doCirrusLogin = exports.useCirrusLoginCredentials = void 0;
const react_query_1 = require("react-query");
const useCirrus_1 = require("../../hooks/useCirrus");
function useCirrusLoginCredentials(credentials) {
    const { host, socket } = useCirrus_1.useCirrus();
    return react_query_1.useQuery([
        'session-id-login',
        serializeSocket(socket),
        host,
        typeof credentials === 'function' ? 'fn' : credentials,
    ], () => __awaiter(this, void 0, void 0, function* () {
        const abortController = new AbortController();
        const creds = typeof credentials === 'function' ? yield credentials() : credentials;
        return doCirrusLogin(socket, creds, { abortController });
    }), { enabled: !!credentials, cacheTime: 1 * 60 * 1000, staleTime: 1 * 60 * 1000, retry: false });
}
exports.useCirrusLoginCredentials = useCirrusLoginCredentials;
function doCirrusLogin(socket, credentials, options) {
    const promise = socket.open().then(() => {
        if (options.abortController.signal.aborted) {
            throw new react_query_1.CancelledError();
        }
        return socket.login(credentials);
    });
    promise.cancel = () => options.abortController.abort();
    return promise;
}
exports.doCirrusLogin = doCirrusLogin;
function serializeSocket(socket) {
    return `YanziSocket-${socket.id}`;
}
//# sourceMappingURL=useCirrusLoginCredentials.js.map